import "./card.css";

// disabled: mục thông tin bị giới hạn, làm mờ và không cho bấm
const Card = ({ icon, title, onClick, disabled }) => {
  return (
    <div className={disabled ? "card card-disabled" : "card"} onClick={disabled ? undefined : onClick}>
      <div className="card-content">
        <img src={icon} alt={title} className="img-card" />
        <p className="card-title">{title}</p>
      </div>
    </div>
  );
};

export default Card;
